import themeConfig from '@themeConfig'
import axios from '@/plugins/axios'

export default {
  namespaced: true,
  state: {
    dialog: false,
    app: {
      contentLayoutNav: themeConfig.app.contentLayoutNav,
      routeTransition: themeConfig.app.routeTransition,
      skinVariant: localStorage.getItem('materio-skin-variant')
        ? localStorage.getItem('materio-skin-variant')
        : themeConfig.app.skinVariant,
      contentWidth: themeConfig.app.contentWidth,
    },
    menu: {
      isMenuHidden: themeConfig.menu.isMenuHidden,
      isVerticalNavMini: themeConfig.menu.isVerticalNavMini,
    },
    appBar: {
      type: themeConfig.appBar.type,
      isBlurred: themeConfig.appBar.isBlurred,
    },
    footer: {
      type: themeConfig.footer.type,
    },
    themes: themeConfig.themes,
  },
  getters: {
    getDialog(state) {
      return state.dialog
    },

    // getApp(state){
    //   return state.app
    // },
    // getMenu(state){
    //   return state.menu
    // },
    // getAppBar(state){
    //   return state.appBar
    // },
    // getFooter(state){
    //   return state.footer
    // }

  },
  mutations: {
    setDialog(state, value) {
      state.dialog = value
    },

    UPDATE_APP_ROUTE_TRANSITION(state, value) {
      state.app.routeTransition = value
    },
    UPDATE_CONTENT_LAYOUT_NAV(state, value) {
      state.app.contentLayoutNav = value
    },
    UPDATE_APP_SKIN_VARIANT(state, value) {
      state.app.skinVariant = value
    },
    UPDATE_APP_CONTENT_WIDTH(state, value) {
      state.app.contentWidth = value
    },
    TOGGLE_MENU_MENU_HIDDEN(state, value) {
      state.menu.isMenuHidden = value
    },
    TOGGLE_MENU_VERTICAL_NAV_MINI(state, value) {
      state.menu.isVerticalNavMini = value
    },
    UPDATE_APP_BAR_TYPE(state, value) {
      state.appBar.type = value
    },
    UPDATE_APP_BAR_IS_BLURRED(state, value) {
      state.appBar.isBlurred = value
    },
    UPDATE_FOOTER_TYPE(state, value) {
      state.footer.type = value
    },
    UPDATE_THEMES(state, value) {
      state.themes = value
    },
  },
  actions: {
    saveConfig({ state }) {
      const data = {
        // app_content_layout_nav: state.app.contentLayoutNav?'yes':'not',
        app_content_width: state.app.contentWidth,

        // app_route_transition: state.app.routeTransition,
        app_skin_variant: state.app.skinVariant,

        // menu_is_menu_hidden: state.menu.isMenuHidden?'yes':'not',
        menu_is_vertical_nav_mini: state.menu.isVerticalNavMini ? 'yes' : 'not',

        // app_bar_is_blurred:state.appBar.isBlurred?'yes':'not',
        app_bar_type: state.appBar.type,

        // footer_type: state.footer.type,
        // rtl: null,
        // theme: null,
        // theme_dark: null ,
        // theme_light: null,
      }

      return axios.post('config/style', data)
    },
    loadConfig({ state }) {
      axios.get('config/style').then(response => {
        state.app.contentWidth = response.data.app_content_width
        state.app.skinVariant = response.data.app_skin_variant
        state.menu.isVerticalNavMini = response.data.menu_is_vertical_nav_mini == 'yes'
        state.appBar.type = response.data.app_bar_type
      })
    },

  },
}
